/*
 * Presento Pronto: gemeinsamer Kern fuer alle Lieferdatum-Berechnungen.
 * Wird ueber snippets/pp-delivery-core.liquid als Modul geladen (type="module":
 * gleiche URL wird nur einmal geladen und ausgefuehrt, egal wie oft das Snippet gerendert wird).
 *
 * Stellt window.ppDelivery bereit und meldet danach auf document das Event 'pp:delivery-ready'.
 * Verbraucher warten so:
 *   if (window.ppDelivery) start(); else document.addEventListener('pp:delivery-ready', start, { once: true });
 *
 * Die Liquid-Konfiguration (Bestellschluss, Produktion, Laufzeit, Feiertage ...) steht weiterhin
 * als data-Attribute am jeweiligen Element (snippets/pp-logistics-attrs) und wird per readConfig gelesen.
 */
window.ppDelivery =
  window.ppDelivery ||
  (function () {
    var TZ = 'Europe/Berlin';
    var DAY_MS = 86400000;
    var partsFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    });
    var dateFormatter = new Intl.DateTimeFormat('de-DE', {
      timeZone: 'UTC',
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    });

    var weekdayFormatter = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'long' });

    function toIso(date) {
      return date.toISOString().slice(0, 10);
    }

    function nextDay(date) {
      return new Date(date.getTime() + DAY_MS);
    }

    function berlinNow() {
      var parts = {};
      partsFormatter.formatToParts(new Date()).forEach(function (part) {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      return parts;
    }

    /* ---------- Automatischer Kalender (jedes Jahr neu berechnet) ---------- */
    function utc(y, m, d) {
      return new Date(Date.UTC(y, m - 1, d));
    }

    function addDays(date, n) {
      return new Date(date.getTime() + n * DAY_MS);
    }

    /* Ostersonntag nach dem anonymen gregorianischen Algorithmus (Gauss) */
    function easter(y) {
      var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
      var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
      return utc(y, month, day);
    }

    function secondSundayOfMay(y) {
      var first = utc(y, 5, 1);
      return addDays(first, ((7 - first.getUTCDay()) % 7) + 7);
    }

    var OCCASIONS = [
      { key: 'valentinstag', label: 'Valentinstag', lead: 21, match: /valentin/i, date: function (y) { return utc(y, 2, 14); } },
      { key: 'ostern', label: 'Ostern', lead: 21, match: /oster/i, date: easter },
      { key: 'muttertag', label: 'Muttertag', lead: 21, match: /mutter/i, date: secondSundayOfMay },
      { key: 'vatertag', label: 'Vatertag', lead: 21, match: /vater/i, date: function (y) { return addDays(easter(y), 39); } },
      { key: 'halloween', label: 'Halloween', lead: 21, match: /halloween/i, date: function (y) { return utc(y, 10, 31); } },
      { key: 'weihnachten', label: 'Weihnachten', lead: 38, match: /weihnacht/i, date: function (y) { return utc(y, 12, 24); } },
    ];

    function holidaysFor(y) {
      var e = easter(y);
      return [
        utc(y, 1, 1), addDays(e, -2), addDays(e, 1), utc(y, 5, 1), addDays(e, 39), addDays(e, 50),
        utc(y, 10, 3), utc(y, 10, 31), utc(y, 12, 25), utc(y, 12, 26),
      ].map(toIso);
    }

    function findOccasion(text) {
      if (!text) return null;
      for (var n = 0; n < OCCASIONS.length; n += 1) {
        if (OCCASIONS[n].key === text || OCCASIONS[n].match.test(text)) return OCCASIONS[n];
      }
      return null;
    }

    function nextOccasionDate(occasion, today) {
      var y = today.getUTCFullYear();
      var date = occasion.date(y);
      return date < today ? occasion.date(y + 1) : date;
    }

    function activeOccasion(result) {
      var today = result.today;
      var best = null;
      [today.getUTCFullYear(), today.getUTCFullYear() + 1].forEach(function (year) {
        OCCASIONS.forEach(function (occasion) {
          var date = occasion.date(year);
          var deadline = addDays(date, -1);
          var from = addDays(date, -occasion.lead);
          if (today >= from && today <= deadline && result.latest <= deadline && (!best || date < best.date)) {
            best = { key: occasion.key, label: occasion.label, date: date };
          }
        });
      });
      return best;
    }

    function readConfig(element) {
      var d = element.dataset;
      var transitMin = Number(d.transitMin) || 1;
      return {
        cutoff: Number(d.cutoff),
        production: Number(d.production) || 0,
        transitMin: transitMin,
        transitMax: Math.max(Number(d.transitMax) || transitMin, transitMin),
        shipSaturday: d.shipSaturday === 'true',
        deliverSaturday: d.deliverSaturday === 'true',
        holidays: (function () {
          var year = berlinNow().year;
          var list = (d.holidays || '').split(/[\s,;]+/).filter(Boolean);
          return new Set(list.concat(holidaysFor(year), holidaysFor(year + 1)));
        })(),
      };
    }

    function compute(config) {
      function isWorkingDay(date, allowSaturday) {
        var weekday = date.getUTCDay();
        if (weekday === 0) return false;
        if (weekday === 6 && !allowSaturday) return false;
        return !config.holidays.has(toIso(date));
      }
      function addWorkingDays(date, count, allowSaturday) {
        var result = date;
        var remaining = count;
        while (remaining > 0) {
          result = nextDay(result);
          if (isWorkingDay(result, allowSaturday)) remaining -= 1;
        }
        return result;
      }
      function nextWorkingDay(date, allowSaturday) {
        var result = nextDay(date);
        while (!isWorkingDay(result, allowSaturday)) result = nextDay(result);
        return result;
      }

      var now = berlinNow();
      var today = new Date(Date.UTC(now.year, now.month - 1, now.day));
      var minutesLeft = config.cutoff * 60 - (now.hour * 60 + now.minute);
      var beforeCutoff = isWorkingDay(today, config.shipSaturday) && minutesLeft > 0;
      var productionStart = beforeCutoff ? today : nextWorkingDay(today, config.shipSaturday);
      var shipDate = addWorkingDays(productionStart, config.production, config.shipSaturday);
      /* Restzeit bis zum Bestellschluss am Tag des Produktionsstarts: vor 14 Uhr heute, danach der
         naechste Werktag. Wer bis dahin bestellt, bekommt denselben Versandtag (shipDate). */
      var daysToStart = Math.round((productionStart.getTime() - today.getTime()) / DAY_MS);
      var minutesToCutoff = daysToStart * 1440 + minutesLeft;

      return {
        today: today,
        beforeCutoff: beforeCutoff,
        minutesLeft: minutesLeft,
        minutesToCutoff: minutesToCutoff,
        productionStart: productionStart,
        shipDate: shipDate,
        earliest: addWorkingDays(shipDate, config.transitMin, config.deliverSaturday),
        latest: addWorkingDays(shipDate, config.transitMax, config.deliverSaturday),
      };
    }

    function formatDate(date) {
      return dateFormatter.format(date);
    }

    function formatRange(start, end) {
      return toIso(start) === toIso(end) ? formatDate(start) : formatDate(start) + ' – ' + formatDate(end);
    }

    /* Versandtag relativ zu heute: "heute", "morgen", "am Freitag" (bis 6 Tage) oder "am Fr., 9. Okt." */
    function formatShipDay(date, today) {
      var diff = Math.round((date.getTime() - today.getTime()) / DAY_MS);
      if (diff <= 0) return 'heute';
      if (diff === 1) return 'morgen';
      if (diff < 7) return 'am ' + weekdayFormatter.format(date);
      return 'am ' + formatDate(date);
    }

    function formatCountdown(minutes) {
      var hours = Math.floor(minutes / 60);
      var rest = minutes % 60;
      return hours > 0 ? hours + ' Std. ' + rest + ' Min.' : rest + ' Min.';
    }

    return {
      readConfig: readConfig,
      compute: compute,
      toIso: toIso,
      formatDate: formatDate,
      formatRange: formatRange,
      formatCountdown: formatCountdown,
      formatShipDay: formatShipDay,
      activeOccasion: activeOccasion,
      findOccasion: findOccasion,
      nextOccasionDate: nextOccasionDate,
      utc: utc,
    };
  })();

document.dispatchEvent(new CustomEvent('pp:delivery-ready', { detail: window.ppDelivery }));
